import React from "react"
import * as R from "ramda"
import ReactMarkdown from "react-markdown"

import Box from "@material-ui/core/Box"

const BasicPageParagraph = ({ pageContent }) => {
  const title = R.path(["title"], pageContent)

  // Youtube embedly help
  const regexEmbedlyText = new RegExp("Embedded content: (.*)", "g")
  const regexYouTube = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-_]*)(&(amp;)?‌​[\w?‌​=]*)?/g
  let textContent = R.path(["contentText", "contentText"], pageContent)
  if (textContent) {
    textContent = textContent
      .replace(regexEmbedlyText, "")
      .replace(regexYouTube, "https://youtu.be/$1?rel=0")
  }

  return (
    <Box>
      <h3>{title}</h3>
      <ReactMarkdown children={textContent} softBreak="br" />
    </Box>
  )
}

export default BasicPageParagraph
